/* eslint-disable */

import React from 'react'
import { TfiApple } from 'react-icons/tfi'
import { DiAndroid } from 'react-icons/di'

const Index = () => {
  const androidLink = 'https://play.google.com/store/apps/details?id=com.bnat'
  const iosLink = ' https://apps.apple.com/app/bnat'

  const handleAndroidClick = () => {
    // Try to open the app first, fallback to Play Store
    window.location.href = androidLink
  }

  const handleIOSClick = () => {
    // Try to open the app first, fallback to App Store
    window.location.href = iosLink
  }
  return (
    <div
      style={{
        backgroundColor: '#844c7a',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '16px',
          padding: '30px 40px',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
          textAlign: 'center',
          width: '420px',
        }}
      >
        <h1
          style={{
            fontSize: '2.2rem',
            fontWeight: 'bold',
            margin: '0 0 10px 0',
            letterSpacing: '2px',
          }}
        >
          BNAT
        </h1>
        <p
          style={{
            fontSize: '1rem',
            color: '#844c7a',
            marginBottom: '20px',
            fontWeight: '600',
          }}
        >
          Open in App
        </p>

        <button
          onClick={handleAndroidClick}
          style={{
            backgroundColor: '#844c7a',
            color: 'white',
            padding: '12px 16px',
            border: 'none',
            borderRadius: '8px',
            width: '100%',
            marginBottom: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            cursor: 'pointer',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)'
          }}
        >
          <span style={{ fontSize: '1.2rem' }}>
            <DiAndroid />
          </span>{' '}
          Open in Android App
        </button>

        <button
          onClick={handleIOSClick}
          style={{
            backgroundColor: '#844c7a',
            color: 'white',
            padding: '12px 16px',
            border: 'none',
            borderRadius: '8px',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            cursor: 'pointer',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)'
          }}
        >
          <span style={{ fontSize: '1.2rem' }}>
            <TfiApple />
          </span>{' '}
          Open in iOS App
        </button>
      </div>
    </div>
  )
}

export default Index
